import ProductCardStyleOne from "./Cards/ProductCardStyleOne";
import DataIteration from "./DataIteration";
import ViewMoreTitle from "./ViewMoreTitle";

export default function SectionStyleThree({
  className,
  sectionTitle,
  seeMoreUrl,
  products = [],
  type,
  openStoreList
}) {
  return (
    <div className={`section-style-one ${className || ""}`}>
      <ViewMoreTitle categoryTitle={sectionTitle} seeMoreUrl={seeMoreUrl}>
        <div className="products-section w-full">
          <div className="grid xl:grid-cols-6 lg:grid-cols-6 sm:grid-cols-3 grid-cols-2 xl:gap-[15px] gap-3">
            {products?.map((item, index) => (
              <div data-aos="fade-up" key={index} className="item">
                <ProductCardStyleOne type={type} datas={item} openStoreList={openStoreList} />
              </div>
            ))}
            {/* <DataIteration datas={products} startLength={0} endLength={12}>
              {({ datas }) => (
                <div data-aos="fade-up" key={datas.id} className="item">
                  <ProductCardStyleOne type={type} datas={datas} />
                </div>
              )}
            </DataIteration> */}
          </div>
        </div>
      </ViewMoreTitle>
    </div>
  );
}
